export default "__VITE_ASSET__DpG6bFUz__"